// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JYAQ","top":"styles_top__3DpJ1"};